module.exports = __webpack_public_path__ + "img/01.df154641.png";